import { ILoan, ILoanRequest, LOAN_STATUS } from "@/types/loan.type";
import { createDebounce } from "../helpers/debounce.helper";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { RenterSuitable } from "@/modules/loan/components/form/fields/SuitableRenterFormik";
import { PaymentInfo } from "@/types/payment.type";

const API_URL = `${import.meta.env.VITE_API_URL}/loans`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getLoans({
  status = [],
  search = "",
  startDate = "",
  endDate = "",
  startDateAtualizadoEm = "",
  endDateAtualizadoEm = "",
  page = 1,
  itemsPerPage = "",
  orderBy = "-createdAt",
  fields = "status,createdAt, renterInfo.renterName, renterInfo.renterId, renterInfo.whatsapp, paymentInfo.totalAmountPending, companyId",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });

  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);
  startDate && params.append("filters[startDate]", startDate.toString());
  endDate && params.append("filters[endDate]", endDate.toString());
  startDateAtualizadoEm &&
    params.append(
      "filters[startDateAtualizadoEm]",
      startDateAtualizadoEm.toString()
    );
  endDateAtualizadoEm &&
    params.append(
      "filters[endDateAtualizadoEm]",
      endDateAtualizadoEm.toString()
    );

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    ILoan[]
  > & { totalItems: number };
  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function getLoanById(loanId: string) {
  const url = `${API_URL}/${loanId}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<ILoan>;
  return result;
}
export async function getSuitableRenter() {
  const url = `${API_URL}/suitable-renters`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    RenterSuitable[]
  >;
  return result;
}

export async function getSuitablePayments(renterId: string) {
  const url = `${API_URL}/suitable-payments/${renterId}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    PaymentInfo[]
  >;
  return result;
}

export async function createLoan(loanData: ILoanRequest) {
  const url = `${API_URL}/`;
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ loanData }),
  };
  const result = (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<ILoan>
  >;
  return result;
}

export async function updateLoan(loanId: string, loanData: Partial<ILoan>) {
  const url = `${API_URL}/${loanId}`;
  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ loanData }),
  };
  const result = (await makeRequest(url, options)) as unknown as Promise<
    ApiResponseType<ILoan>
  >;
  return result;
}
export async function updateLoanStatus(loanId: string, status: LOAN_STATUS) {
  const url = `${API_URL}/status/${loanId}`;
  const options = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ status }),
  };
  const result = (await makeRequest(url, options)) as unknown as Promise<
    ApiResponseType<ILoan>
  >;
  return result;
}
